export default __webpack_public_path__ + "static/media/036-binoculars.8aaea98e.png";